module.exports = __webpack_public_path__ + "img/advertencia.17bb9ad6.svg";